import { useRoute } from '#imports'

import {
  landingReviewsAPI,
  merchantShopAPI,
  productAPI,
  productListPageAPI,
  productReviewsAPI,
  reviewsAPI,
  sellerReviewsAPI,
} from '@backmarket/http-api'
import { getSeoTags } from '@backmarket/http-api/src/api-specs-acquisition/link-booster'

import { ROUTES } from '../route-names'

// TODO Use dedicated service to request the title once it has been created
export function useRequests() {
  const route = useRoute()

  switch (route.name) {
    case ROUTES.PAGES.PRODUCT:
      return {
        ...productReviewsAPI,
        getTitle: productAPI.getProduct,
        getSeoTags,
      }

    case ROUTES.PAGES.LANDING:
      return {
        ...landingReviewsAPI,
        getTitle: productListPageAPI.getProductListPage,
        getSeoTags,
      }

    case ROUTES.PAGES.MERCHANT:
      return {
        ...sellerReviewsAPI,
        getTitle: merchantShopAPI.getMerchantShop,
      }

    case ROUTES.PAGES.ALL:
      return reviewsAPI

    default:
      return undefined
  }
}
